<template>  
  <div id="mains" ref="main">
    <div class="headers">
      <headers></headers>
    </div>
    <div class="mainBox">
      <router-view/>
    </div>
    <div class="footers">
      <footers></footers>
    </div>
  </div>
</template>

<script>
import headers from "../components/mains/headers.vue"
import footers from "../components/mains/footers.vue"
export default {
  name: 'mains',
  components: {
    headers,
    footers
  },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  watch: {
    $route (val) {
      this.$refs.main.scrollTop = 0;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  #mains{
    width: 100%;
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;//该属性随着手指离开还会保持滚动
    .headers{
      width: 100%;
      height: 75px;
    }
    .mainBox{
      width: 100%;
      height: auto;
      overflow: hidden;
    }
    .footers{
      width: 100%;
      min-height: 240px;
    }
    
    /* 谷歌  input去除加减按钮效果*/
     input::-webkit-outer-spin-button,
     input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        appearance: none;
        margin: 0;
    }
    /* 火狐 input去除加减按钮效果*/
    input{ -moz-appearance:textfield;}

    textarea { /* textarea 默认字体修改 */
      /* font-family: Arial, Helvetica, sans-serif; */
      font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
  }
</style>


// WEBPACK FOOTER //
// src/page/mains.vue